import React, { createContext, useState } from "react";

export const FormValidateContext = createContext(null);

const FormValidateValue = () => {
    const [fields, setFields] = useState([]); 
    const [errors, setErrors] = useState([]);

    const registerField = (field) => {
        setFields((_fields) => [..._fields, field]);
    };

    const unregisterField = (field) => {
        setFields((_fields) => _fields.filter((_field) => _field.id !== field.id));
    };

    const getFieldError = (_id) => errors.find((err) => err.id === _id);

    const validateForm = () => {
        const validationErrors = [];
        let firstInvalidField = null;

        // eslint-disable-next-line no-unsafe-optional-chaining
        fields?.sort((a, b) => a?.ref?.current.offsetTop - b?.ref?.current.offsetTop).forEach((_field) => {
            const fieldValidation = _field.validate();
            if (fieldValidation !== true) {
                validationErrors.push({ id: _field.id, message: fieldValidation });

                if (!firstInvalidField) {
                    firstInvalidField = _field.ref;
                }
            }
        });
        
        setErrors(validationErrors);
        if (firstInvalidField && firstInvalidField.current) {
            firstInvalidField.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }

        return validationErrors.length === 0;
    };

    const clearFieldError = (_id) => {
        setErrors((_errors) => _errors.filter((err) => err.id !== _id));
    };

    return {
        registerField, unregisterField, validateForm, errors, getFieldError, clearFieldError,
    };
};

const FormValidateProvider = ({ children }) => {
    const value = FormValidateValue();

    return (
        <FormValidateContext.Provider value={value}>
            {children}
        </FormValidateContext.Provider>
    );
};

export default FormValidateProvider;
